import React from 'react';
import { FiBookOpen, FiMonitor } from 'react-icons/fi';
import { useReadingMode } from '../../contexts/ReadingModeContext';

const ReadingModeToggle: React.FC = () => {
  const { isReadingMode, toggleReadingMode } = useReadingMode();

  return (
    <button
      className={`reading-mode-toggle ${isReadingMode ? 'active' : ''}`}
      onClick={toggleReadingMode}
      aria-label={isReadingMode ? 'Desactivar modo lectura' : 'Activar modo lectura'}
      title={isReadingMode ? 'Modo lectura activo' : 'Activar modo lectura'}
    >
      {isReadingMode ? <FiBookOpen size={20} /> : <FiMonitor size={20} />}
    </button>
  );
};

export default ReadingModeToggle;
